import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  class: "h-full w-full",
  viewBox: "0 0 72 72"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      "data-name": "Group 4540",
      transform: "translate(-915 -395)"
    }, [
      _createElementVNode("circle", {
        cx: "36",
        cy: "36",
        r: "36",
        "data-name": "Ellipse 69",
        transform: "translate(915 395)"
      }),
      _createElementVNode("path", {
        fill: "#fff",
        d: "M962.149 427.131h-1.334l-.11-.274a21 21 0 0 1-.4-1.169 18.4 18.4 0 0 0-1.863-4.219 7.67 7.67 0 0 0-5.99-3.47h-4.567c-3.013 0-5.534 2.027-6.9 5.589-.164.438-.511 2.155-.785 3.561h-1a6.2 6.2 0 0 0-6.2 6.191v1.187a6.29 6.29 0 0 0 3.744 5.7 4.677 4.677 0 0 0 9.187.511h9.969a4.673 4.673 0 0 0 9.2-.767 6.2 6.2 0 0 0 3.233-5.443v-1.188a6.19 6.19 0 0 0-6.184-6.209m-15.287-6.813v6.794h-4.4a28 28 0 0 1 .6-2.776c.494-1.278 1.645-3.47 3.8-4.018m6.045 3.47a1.1 1.1 0 0 0-.493 1.479l.931 1.863h-4.273v-6.94h3.4a5.48 5.48 0 0 1 4.128 2.466 15.6 15.6 0 0 1 1.625 3.762c.073.237.164.475.237.712h-2.651l-1.425-2.849a1.1 1.1 0 0 0-1.479-.492Zm5.169 15.177a2.465 2.465 0 0 1 4.73-.11 2.6 2.6 0 0 1 .11.749 1.9 1.9 0 0 1-.073.548 2.465 2.465 0 0 1-4.785.091 2.7 2.7 0 0 1-.091-.639 4 4 0 0 1 .109-.638Zm8.072-5.643v1.187a4.06 4.06 0 0 1-1.461 3.09 4.675 4.675 0 0 0-8.767.913h-9.971a4.681 4.681 0 0 0-8.894-.639 3.92 3.92 0 0 1-1.826-3.342v-1.191a3.99 3.99 0 0 1 3.981-3.981h22.939a3.97 3.97 0 0 1 3.999 3.963M941.4 442.07a2.5 2.5 0 0 1-2.393-1.845 2.6 2.6 0 0 1-.091-.621 3 3 0 0 1 .091-.676 2.463 2.463 0 0 1 4.749.037 2.7 2.7 0 0 1 .091.639 2.6 2.6 0 0 1-.091.639 2.424 2.424 0 0 1-2.356 1.827",
        "data-name": "Path 2612"
      })
    ], -1)
  ])))
}
export default { render: render }